import { formatPersonName, type Voice } from '@gb-ticket/shared-types';
import { type ReactNode } from 'react';

import { cn } from '@/lib/utils';
import { useVoice } from '@/platform/voice/use-voice';
import { useColleagueProfile } from '@/products/intranet/features/intranet/colleague-profile-context';

/** Visible person label for the tenant voice. */
export function colleagueVisibleName(displayName: string, voice: Voice): string {
  return formatPersonName({ displayName }, voice);
}

/** Opens the shared colleague sheet. Accessible name is always Vorname Nachname. */
export function ColleagueNameButton({
  userId,
  displayName,
  className,
  children,
}: {
  userId: string;
  displayName: string;
  className?: string;
  children?: ReactNode;
}) {
  const { open } = useColleagueProfile();
  const voice = useVoice();
  const label = colleagueVisibleName(displayName, voice);

  return (
    <button
      type="button"
      aria-haspopup="dialog"
      aria-label={label}
      disabled={!userId}
      className={cn(
        'group cursor-pointer rounded-md underline-offset-4 transition-colors hover:text-primary hover:underline focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:text-inherit disabled:hover:no-underline',
        className,
      )}
      onClick={() => open(userId)}
    >
      {children ?? label}
    </button>
  );
}
